grecaptcha.ready((function () {
  // Declaração de variável
  var e = document.getElementById("sitekey").value;

  // Chamada da função grecaptcha.execute()
  grecaptcha.execute(e, { action: "submit" }).then((function (e) {
    // Declaração de variável
    document.getElementById("g-recaptcha-response").value = e;
  }));
}));